import React from 'react';
import { SettingsBreadcrumbs } from '../../settingsModule';
import InnerBlock from '../../../shared/web/layout/InnerBlock';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';
import MarketRequestsList from './MarketRequestsList';
import { MarketRequestFormButton } from './MarketRequestForm';

export default function MarketRequestsListPage() {

  // get GET parameter for 'openForm'
  const urlParams = new URLSearchParams(window.location.search);
  const openForm = urlParams.get('openForm') === '1';

  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Markets" href="/settings/markets">
          <Breadcrumb text="Market Requests" />
        </Breadcrumb>
      </SettingsBreadcrumbs>
      <InnerBlock title="Market Requests" headerRight={(
        <MarketRequestFormButton
          openForm={openForm}
        />
      )}>
        <MarketRequestsList />
      </InnerBlock>
    </>
  );
}
